import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { MultiLineText, SingleSelect, Text } from 'Shared/forms/Inputs';
import { LabelOnLeftWrap, noteStyle, Wrap } from 'Shared/forms/Wrap';
import type {EmbedLayout} from 'Shared/model/Components';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import { Match, Switch } from 'solid-js';


export function EmbedBody(P:EmbedLayout)
{
	return (<>
		<div class={noteStyle()}>
			WARNING: only paste in code from providers you trust. Malicious code can trick visitors into
			providing personal information or display undesirable content on your pages.
			The 'Iframe' option is more secure than the 'Code' option.
		</div>

		<LabelOnLeftWrap label='Embed type'>
			<SingleSelect field='type'
				options={{iframe:'Iframe',code:'Code'}}
				required={true}
				initialValue='iframe'
				subdoc={{
					name: 'height',
					onChange: (newType, _oldType, oldHeight) => newType === 'iframe' ? (oldHeight ?? {parent:true}) : undefined
				}}
			/>
		</LabelOnLeftWrap>

		<Switch>
			<Match when={P.type == 'iframe'}>
				<IFrame {...P} />
			</Match>
			<Match when={true}>
				<Js {...P} />
			</Match>
		</Switch>
	</>);
}

function IFrame(P)
{
	const sw = useStore();

	return (<>
		<StoreProvider {...sw} location={[...sw.location,'height']} >
			<VerticalConstraint {...P.height} label='Height' options={P.heightOptions} />
		</StoreProvider>

		<Wrap label='Embed iframe URL'>
			<Text field='url' required={true} />
		</Wrap>
	</>);
}

function Js(P)
{
	return (
		<div>
			<Wrap label='HTML embed code'>
				<MultiLineText field='code' numRows={8} />
			</Wrap>
		</div>
	);
}

